export default "__VITE_ASSET__Cp7$67TL__"